<template>
  <div class="headermain">
    <div class="headerleft">拱墅区卫监笔录系统</div>
    <div class="headerright">
      <img src="../images/lingdang.png" alt class="ldimg" />
      <span>欢迎您，</span>
      <img src="../images/touxiang.png" alt class="outimgs" />
      <span>{{name||"超级管理员"}}</span>
      <img src="../images/out.png" alt class="outimg" />
      <span @click="out" style="cursor:pointer;margin-left:10px">
        <!-- <img alt  /> -->
        退出
      </span>
    </div>
  </div>
</template>

<style type="text/scss" scoped>
.logoimg {
  width: 30px;
  margin-right: 15px;
}

.ldimg {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.outimg {
  width: 20px;
  height: 20px;
  margin-left: 15px;
}

.outimgs {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.logorimg {
  width: 150px;
  height: 30px;
  margin-right: 20px;
}

.headermain {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #3370ff;
  padding: 0 20px;
  box-shadow: 0px 0px 8px 0px rgba(110, 114, 117, 0.5) !important;
  color: white;
}

.headerleft {
  font-size: 24px;
  /* font-family: Alibaba PuHuiTi; */
  font-weight: bold;
  color: white;
  line-height: 9px;
  display: flex;
  align-items: center;
}

.headerright {
  text-align: right;
  display: flex;
  align-items: center;
  height: 70px;
  line-height: 70px;
}
</style>

<script>
export default {
  data() {
    return {
      name: localStorage.getItem("username")
    };
  },
  methods: {
    out() {
      localStorage.clear();
      window.location.href = "/";
      // window.location.reload();
    }
  }
};
</script>